export function IndustrialBlueprintStyles() {
    return (
        <style>{`
            .web-industrial-blueprint {
                background: var(--site-background);
                color: var(--site-text);
                container-name: industrial-template;
                container-type: inline-size;
                isolation: isolate;
                scroll-behavior: smooth;
                scroll-padding-top: 112px;
            }

            .web-industrial-blueprint ::selection {
                background: var(--site-accent);
                color: var(--site-background);
            }

            .web-industrial-blueprint :focus-visible {
                outline: 3px solid var(--site-accent);
                outline-offset: 4px;
            }

            .web-industrial-blueprint *,
            .web-industrial-blueprint *::before,
            .web-industrial-blueprint *::after {
                box-sizing: border-box;
            }

            .web-industrial-blueprint .site-builder-section,
            .web-industrial-blueprint [data-site-builder-block="footer"] {
                padding-inline: clamp(1.25rem, 2vw, 2rem);
                position: relative;
            }

            .web-industrial-blueprint .site-builder-grid {
                display: grid;
                gap: clamp(1.25rem, 2.8vw, 2.65rem);
                margin-inline: auto;
                width: min(100%, var(--site-container));
            }

            .web-industrial-blueprint .site-builder-grid:not(.site-builder-grid-placed) {
                grid-template-columns: repeat(12, minmax(0, 1fr));
            }

            .web-industrial-blueprint .site-builder-grid:not(.site-builder-grid-placed) > .site-builder-grid-item {
                grid-column: 1 / -1;
            }

            .web-industrial-blueprint .site-builder-column {
                align-content: start;
                display: grid;
                gap: 1.15rem;
                min-width: 0;
            }

            .web-industrial-blueprint .site-builder-column-inline {
                align-items: center;
                display: flex;
                flex-wrap: wrap;
            }

            .web-industrial-blueprint .site-builder-text-h1,
            .web-industrial-blueprint .site-builder-text-h2,
            .web-industrial-blueprint .site-builder-text-h3 {
                overflow-wrap: normal !important;
                text-wrap: balance;
                word-break: normal;
            }

            .web-industrial-blueprint .site-builder-text-h1 {
                max-width: 12ch;
            }

            .web-industrial-blueprint .site-builder-text-h2 {
                max-width: 14ch;
            }

            .web-industrial-blueprint .site-builder-button {
                border-radius: 0 !important;
                clip-path: polygon(0 0, calc(100% - 11px) 0, 100% 11px, 100% 100%, 0 100%);
                justify-content: center;
                text-transform: uppercase;
                transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease, transform 180ms ease;
            }

            .web-industrial-blueprint .site-builder-button:hover {
                transform: translateX(4px);
            }

            .web-industrial-blueprint .site-builder-card {
                border-radius: 0 !important;
                box-shadow: none;
                transition: border-color 240ms ease, box-shadow 240ms ease, transform 240ms ease;
            }

            .web-industrial-blueprint .site-builder-card:hover {
                border-color: var(--site-accent) !important;
                box-shadow: 0 18px 42px color-mix(in srgb, var(--site-text) 10%, transparent);
                transform: translateY(-5px);
            }

            .web-industrial-blueprint [data-site-builder-block="badge"] {
                border-radius: 0 !important;
            }

            .web-industrial-blueprint [data-web-region="serviceStrip"] {
                left: 0;
                padding-inline: clamp(1rem, 2vw, 2rem);
                position: sticky;
                right: 0;
                top: 0;
                z-index: 62;
            }

            .web-industrial-blueprint [data-web-region="serviceStrip"] > .site-builder-grid,
            .web-industrial-blueprint [data-web-region="header"] > .site-builder-grid {
                align-items: center;
            }

            .web-industrial-blueprint [data-web-region="header"] {
                left: 0;
                padding-inline: clamp(1rem, 2vw, 2rem);
                position: sticky;
                right: 0;
                top: 36px;
                transition: box-shadow 220ms ease, background-color 220ms ease;
                z-index: 60;
            }

            .web-industrial-blueprint [data-web-region="header"][data-industrial-header-scrolled] {
                box-shadow: 0 10px 34px color-mix(in srgb, var(--site-text) 18%, transparent);
            }

            .web-industrial-blueprint [data-document-role="brand"] {
                clip-path: polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%);
                margin-left: clamp(-2rem, -2vw, -1rem);
                padding-right: clamp(2.25rem, 3.5vw, 3.5rem) !important;
            }

            .web-industrial-blueprint [data-document-role="headerNavigation"] .site-navigation-primary {
                gap: clamp(.1rem, .35vw, .35rem);
            }

            .web-industrial-blueprint [data-document-role="headerNavigation"] .site-navigation-primary-trigger,
            .web-industrial-blueprint [data-document-role="headerNavigation"] .site-navigation-primary-link {
                font-size: .7rem;
                padding-inline: clamp(.3rem, .55vw, .5rem);
            }

            .web-industrial-blueprint [data-document-role="headerActions"] {
                flex-wrap: nowrap;
                justify-content: flex-end;
                padding-left: clamp(.5rem, 1vw, 1rem);
            }

            .web-industrial-blueprint [data-document-role="headerCta"] {
                flex: 0 0 auto;
                min-width: 0 !important;
                padding-inline: clamp(.85rem, 1.5vw, 1.35rem) !important;
            }

            .web-industrial-blueprint [data-web-region="homeHero"] {
                overflow: hidden;
                padding-inline: 0;
            }

            .web-industrial-blueprint [data-web-region="homeHero"] > .site-builder-grid {
                gap: 0 !important;
                grid-auto-rows: minmax(0, auto) !important;
                grid-template-columns: minmax(0, .92fr) minmax(520px, 1.08fr) !important;
                max-width: none;
                width: 100%;
            }

            .web-industrial-blueprint [data-web-region="homeHero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroCopy"]) {
                grid-column: 1 !important;
                grid-row: 1 !important;
            }

            .web-industrial-blueprint [data-web-region="homeHero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroVisual"]) {
                grid-column: 2 !important;
                grid-row: 1 !important;
            }

            .web-industrial-blueprint [data-document-role="heroCopy"] {
                padding-left: max(1.25rem, calc((100cqw - var(--site-container)) / 2));
            }

            .web-industrial-blueprint [data-document-role="heroCopy"]:has(> [data-document-role="heroHeading"]) {
                align-content: center;
                column-gap: .75rem;
                display: grid;
                grid-template-columns: repeat(12, minmax(0, 1fr));
                row-gap: 1.15rem;
            }

            .web-industrial-blueprint [data-document-role="heroCopy"] > :not([data-document-role="heroPrimaryAction"], [data-document-role="heroSecondaryAction"]) {
                grid-column: 1 / -1;
            }

            .web-industrial-blueprint [data-document-role="heroPrimaryAction"] {
                grid-column: 1 / span 6;
            }

            .web-industrial-blueprint [data-document-role="heroSecondaryAction"] {
                grid-column: 7 / span 6;
            }

            .web-industrial-blueprint [data-document-role="heroVisual"] {
                isolation: isolate;
                overflow: hidden;
                position: relative;
            }

            .web-industrial-blueprint [data-document-role="heroVisual"]::before {
                background: linear-gradient(90deg, rgb(0 0 0 / .3), transparent 46%), linear-gradient(0deg, rgb(0 0 0 / .45), transparent 52%);
                content: "";
                inset: 0;
                pointer-events: none;
                position: absolute;
                z-index: 1;
            }

            .web-industrial-blueprint [data-document-role="heroVisual"]::after {
                background: var(--site-accent);
                bottom: -1px;
                clip-path: polygon(0 62%, 100% 0, 68% 100%, 0 100%);
                content: "";
                height: min(28cqw, 350px);
                left: -1px;
                mix-blend-mode: multiply;
                opacity: .88;
                pointer-events: none;
                position: absolute;
                width: min(27cqw, 340px);
                z-index: 2;
            }

            .web-industrial-blueprint [data-document-role="heroImage"] {
                inset: 0;
                position: absolute;
            }

            .web-industrial-blueprint [data-document-role="heroImage"] .site-builder-image {
                filter: grayscale(100%) contrast(1.08);
                height: 100% !important;
                max-width: none;
                object-fit: cover;
                width: 100% !important;
            }

            .web-industrial-blueprint [data-document-role="heroFloatingProof"] {
                bottom: clamp(1.25rem, 3vw, 2.25rem);
                border-left: 4px solid var(--site-accent) !important;
                position: absolute;
                right: clamp(1.25rem, 3vw, 2.25rem);
                z-index: 4;
            }

            .web-industrial-blueprint [data-web-region="homeTrust"] {
                padding-inline: clamp(1.25rem, 2vw, 2rem);
            }

            .web-industrial-blueprint [data-web-region="homeTrust"] > .site-builder-grid {
                gap: 0 !important;
            }

            .web-industrial-blueprint [data-web-region="homeTrust"] .site-builder-card:hover,
            .web-industrial-blueprint [data-web-region="homeProcess"] .site-builder-card:hover,
            .web-industrial-blueprint [data-web-region="contactSteps"] .site-builder-card:hover {
                box-shadow: none;
            }

            .web-industrial-blueprint [data-document-role="editorialVisual"] {
                clip-path: polygon(0 0, 100% 0, 100% calc(100% - 46px), calc(100% - 46px) 100%, 0 100%);
                overflow: hidden;
                position: relative;
            }

            .web-industrial-blueprint [data-document-role="editorialVisual"] .site-builder-image {
                filter: grayscale(100%) contrast(1.05);
                height: 100% !important;
                object-fit: cover;
                transition: filter 500ms cubic-bezier(.2,.7,.2,1), transform 700ms cubic-bezier(.2,.7,.2,1);
                width: 100% !important;
            }

            .web-industrial-blueprint [data-document-role="editorialVisual"]:hover .site-builder-image {
                filter: grayscale(0%) contrast(1);
                transform: scale(1.025);
            }

            .web-industrial-blueprint [data-web-region="homeModules"] .site-builder-card,
            .web-industrial-blueprint [data-web-region="homeFeatures"] .site-builder-card,
            .web-industrial-blueprint [data-web-region="modulesGrid"] .site-builder-card,
            .web-industrial-blueprint [data-web-region="featuresGrid"] .site-builder-card {
                border-top: 4px solid var(--site-primary) !important;
            }

            .web-industrial-blueprint [data-web-region="homeModules"] .site-builder-card:hover,
            .web-industrial-blueprint [data-web-region="homeFeatures"] .site-builder-card:hover,
            .web-industrial-blueprint [data-web-region="modulesGrid"] .site-builder-card:hover,
            .web-industrial-blueprint [data-web-region="featuresGrid"] .site-builder-card:hover {
                border-top-color: var(--site-accent) !important;
            }

            .web-industrial-blueprint [data-site-builder-block="accordion"],
            .web-industrial-blueprint [data-site-builder-block="accordionItem"] {
                border-radius: 0 !important;
            }

            .web-industrial-blueprint [data-web-region$="Cta"] .site-builder-button,
            .web-industrial-blueprint [data-web-region="homeCta"] .site-builder-button {
                width: 100% !important;
            }

            .web-industrial-blueprint [data-web-region="mobileAction"] {
                display: none;
            }

            .web-industrial-blueprint [data-web-region="footer"] .site-builder-navigation {
                align-items: flex-start;
                flex-direction: column;
                gap: .7rem;
            }

            .web-industrial-blueprint [data-web-region="footer"] a {
                transition: color 180ms ease;
            }

            .web-industrial-blueprint [data-web-region="footer"] a:hover {
                color: var(--site-accent) !important;
            }

            .web-industrial-blueprint:not([data-web-template-editor="true"])[data-industrial-runtime-ready] [data-industrial-reveal]:not([data-industrial-revealed]) {
                opacity: 0;
                transform: translateY(26px);
            }

            .web-industrial-blueprint:not([data-web-template-editor="true"])[data-industrial-runtime-ready] [data-industrial-reveal] {
                opacity: 1;
                transform: translateY(0);
                transition: opacity 700ms cubic-bezier(.2,.7,.2,1), transform 700ms cubic-bezier(.2,.7,.2,1);
                will-change: opacity, transform;
            }

            .web-industrial-blueprint .industrial-mobile-menu-toggle {
                display: none;
            }

            @container industrial-template (max-width: 900px) {
                .web-industrial-blueprint {
                    padding-bottom: 72px;
                }

                .web-industrial-blueprint .site-builder-grid[data-site-builder-stack-on-mobile="true"] {
                    grid-auto-rows: auto !important;
                    grid-template-columns: minmax(0, 1fr) !important;
                    grid-template-rows: none !important;
                }

                .web-industrial-blueprint .site-builder-grid[data-site-builder-stack-on-mobile="true"] > .site-builder-grid-item {
                    grid-column: 1 !important;
                    grid-row: auto !important;
                }

                .web-industrial-blueprint [data-web-region="serviceStrip"] > .site-builder-grid {
                    grid-template-columns: minmax(0, 1fr) auto !important;
                }

                .web-industrial-blueprint [data-web-region="serviceStrip"] > .site-builder-grid > .site-builder-grid-item {
                    grid-column: auto !important;
                    grid-row: 1 !important;
                }

                .web-industrial-blueprint [data-web-region="header"] {
                    min-height: 74px;
                    padding-inline: 1rem;
                }

                .web-industrial-blueprint [data-web-region="header"] > .site-builder-grid {
                    grid-template-columns: minmax(0, 1fr) auto !important;
                }

                .web-industrial-blueprint [data-web-region="header"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="brand"]) {
                    display: block;
                    grid-column: 1 !important;
                    grid-row: 1 !important;
                }

                .web-industrial-blueprint [data-document-role="brand"] {
                    margin-left: -1rem;
                    max-width: 240px;
                    min-height: 74px !important;
                }

                .web-industrial-blueprint [data-web-region="header"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="headerNavigation"]),
                .web-industrial-blueprint [data-web-region="header"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="headerActions"]) {
                    display: none;
                }

                .web-industrial-blueprint [data-web-region="header"] .industrial-mobile-menu-toggle {
                    align-items: center;
                    background: var(--site-surface);
                    border: 1px solid var(--site-border);
                    color: var(--site-text);
                    cursor: pointer;
                    display: grid;
                    gap: 5px;
                    height: 44px;
                    padding: 10px;
                    place-content: center;
                    position: absolute;
                    right: 1rem;
                    top: 15px;
                    width: 44px;
                    z-index: 4;
                }

                .web-industrial-blueprint .industrial-mobile-menu-toggle > span {
                    background: currentColor;
                    display: block;
                    height: 2px;
                    transition: opacity 180ms ease, transform 180ms ease;
                    width: 23px;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] {
                    background: var(--site-background) !important;
                    bottom: 0;
                    left: 0;
                    overflow-y: auto;
                    padding-inline: 1rem;
                    position: fixed;
                    right: 0;
                    top: 0;
                    z-index: 80;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] > .site-builder-grid {
                    align-content: start;
                    min-height: 100%;
                    padding-bottom: 2rem;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="headerNavigation"]),
                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="headerActions"]) {
                    display: block;
                    grid-column: 1 / -1 !important;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="headerNavigation"]) {
                    grid-row: 2 !important;
                    margin-top: clamp(3rem, 9vh, 5rem);
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="headerActions"]) {
                    grid-row: 3 !important;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerNavigation"],
                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerActions"] {
                    align-items: stretch;
                    flex-direction: column;
                    gap: 0 !important;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerNavigation"] .site-builder-text,
                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerNavigation"] .site-navigation-mobile-link,
                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerNavigation"] .site-navigation-mobile-trigger {
                    font-family: var(--site-heading-font) !important;
                    font-size: clamp(1.6rem, 7vw, 2.8rem) !important;
                    font-weight: 800 !important;
                    letter-spacing: -.035em;
                    line-height: 1.15 !important;
                    text-transform: uppercase;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerActions"] {
                    gap: .75rem !important;
                    margin-top: 1rem;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerActions"] > *,
                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] [data-document-role="headerCta"] {
                    width: 100% !important;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] .industrial-mobile-menu-toggle > span:first-child {
                    transform: translateY(7px) rotate(45deg);
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] .industrial-mobile-menu-toggle > span:nth-child(2) {
                    opacity: 0;
                }

                .web-industrial-blueprint [data-web-region="header"][data-industrial-mobile-menu-open] .industrial-mobile-menu-toggle > span:last-child {
                    transform: translateY(-7px) rotate(-45deg);
                }

                .web-industrial-blueprint:has([data-industrial-mobile-menu-open]) [data-web-region="mobileAction"] {
                    display: none;
                }

                .web-industrial-blueprint [data-web-region="homeHero"] > .site-builder-grid {
                    grid-template-columns: minmax(0, 1fr) !important;
                }

                .web-industrial-blueprint [data-web-region="homeHero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroCopy"]),
                .web-industrial-blueprint [data-web-region="homeHero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroVisual"]) {
                    grid-column: 1 !important;
                    grid-row: auto !important;
                }

                .web-industrial-blueprint [data-document-role="heroCopy"] {
                    padding: clamp(3.5rem, 9vw, 5rem) 1.25rem !important;
                }

                .web-industrial-blueprint [data-document-role="heroVisual"] {
                    min-height: 560px !important;
                }

                .web-industrial-blueprint [data-web-region="homeTrust"] > .site-builder-grid {
                    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
                }

                .web-industrial-blueprint [data-web-region="homeTrust"] > .site-builder-grid > .site-builder-grid-item {
                    grid-column: auto !important;
                    grid-row: auto !important;
                }

                .web-industrial-blueprint [data-web-region="mobileAction"] {
                    bottom: 0;
                    display: block;
                    left: 0;
                    padding: 8px;
                    position: fixed;
                    right: 0;
                    z-index: 58;
                }

                .web-industrial-blueprint [data-web-region="mobileAction"] > .site-builder-grid,
                .web-industrial-blueprint [data-web-region="mobileAction"] > .site-builder-grid > .site-builder-grid-item {
                    display: block;
                    width: 100%;
                }
            }

            @container industrial-template (max-width: 560px) {
                .web-industrial-blueprint .site-builder-section,
                .web-industrial-blueprint [data-site-builder-block="footer"] {
                    padding-inline: 1rem;
                }

                .web-industrial-blueprint [data-web-region="serviceStrip"] > .site-builder-grid > .site-builder-grid-item:last-child {
                    display: none;
                }

                .web-industrial-blueprint [data-web-region="serviceStrip"] > .site-builder-grid {
                    grid-template-columns: minmax(0, 1fr) !important;
                }

                .web-industrial-blueprint [data-document-role="heroCopy"]:has(> [data-document-role="heroHeading"]) {
                    display: grid;
                    grid-template-columns: minmax(0, 1fr);
                }

                .web-industrial-blueprint [data-document-role="heroCopy"] > * {
                    grid-column: 1 !important;
                }

                .web-industrial-blueprint [data-document-role="heroVisual"] {
                    min-height: 460px !important;
                }

                .web-industrial-blueprint [data-document-role="heroFloatingProof"] {
                    bottom: 1rem;
                    left: 1rem;
                    max-width: none !important;
                    right: 1rem;
                }

                .web-industrial-blueprint [data-web-region="homeTrust"] > .site-builder-grid {
                    grid-template-columns: minmax(0, 1fr) !important;
                }

                .web-industrial-blueprint [data-web-region="homeTrust"] .site-builder-card {
                    border-bottom: 1px solid var(--site-border) !important;
                    border-right: 0 !important;
                    min-height: 132px !important;
                }
            }

            @media (prefers-reduced-motion: reduce) {
                .web-industrial-blueprint,
                .web-industrial-blueprint * {
                    scroll-behavior: auto !important;
                }

                .web-industrial-blueprint .site-builder-card,
                .web-industrial-blueprint .site-builder-button,
                .web-industrial-blueprint .site-builder-image,
                .web-industrial-blueprint [data-industrial-reveal] {
                    transition-duration: 0s !important;
                }
            }
        `}</style>
    );
}
